const channelTalkKeys = {
  all: ['channelTalk'] as const,
  memberHash: () => [...channelTalkKeys.all, 'memberHash'] as const,
};

export { channelTalkKeys };
